<template>
    <validation-provider v-slot="{ errors }" :name="name" :rules="rules">
        <v-text-field
            v-model="model"
            :name="name"
            outlined
            dense
            :background-color="backgroundClasses"
            :error-messages="errors"
            v-bind="$attrs"
            rounded
            count
            :label="computedLabel"
            :class="{ required: required }"
            :required="required"
        />
    </validation-provider>
</template>

<script>
import VModel from "../../Mixins/VModel";
import FormInput from "../../Mixins/FormInput";

export default {
    name: "TextInput",
    mixins: [VModel, FormInput],
    props: {
        name: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: false,
        },
        rules: {
            type: String,
            default: "",
        },
        required: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        computedLabel() {
            return this.label ? this.label : this.name;
        },
    },
};
</script>
